/**
 * Facts about the service and the company behind it, used by the website, the legal
 * pages, search-engine metadata and the API. Change them here, in one place.
 *
 * TODO before launch: fill in the company's legal details. Danish law (e-handelsloven
 * § 7) and GDPR art. 13 require the operator's name, address, CVR number and a contact
 * email on the website. Empty fields are left out of the pages.
 */
export const SITE = {
  name: "Dolphin Booking",
  /** Production origin, used for canonical links when the API has no APP_ORIGIN. */
  origin: "https://dolphinbooking.com",
  company: {
    legalName: "",
    cvr: "",
    address: "",
    email: "",
  },
} as const;

/**
 * Version of the terms of service and data processing agreement. A clinic accepts it
 * at sign-up (stored on the clinic). Bump it when the published terms change.
 */
export const TERMS_VERSION = "2026-10-07";

/** How long personal data is kept, in the retention job and in the privacy policy. */
export const RETENTION = {
  /** Customers with no booking that ended within this period are anonymised. */
  customerMonths: 24,
  /** Signed-out and expired sessions are deleted after this many days. */
  expiredSessionDays: 30,
  /** SMS delivery records (phone number, status). */
  smsMonths: 6,
  /** Admin console audit log. */
  auditMonths: 24,
} as const;

/**
 * Sub-processors that may handle personal data for the service. Listed in the privacy
 * policy and the data processing agreement; update both when this changes.
 */
export const SUB_PROCESSORS = [
  { name: "Amazon Web Services EMEA SARL (Amazon SES)", purpose: "email", location: "EU (Ireland)" },
  { name: "GatewayAPI (OnlineCity ApS)", purpose: "sms", location: "EU (Denmark)" },
  { name: "Hosting provider of the production server", purpose: "hosting", location: "EU" },
] as const;
